import type { GraphIssue } from '@/types/custom-playbooks';

/** Warnings that never gate the On toggle or Run Test: unwired arms
 *  (§10.1-a, a dropped-arm shape is legal and enable-safe) and the server's
 *  `notify_owner_not_linked` (the agent owner's Clu DM can't be delivered
 *  yet; the play still saves, turns on and runs). The canvas shows them as
 *  warnings, never in the red of an issue that blocks. */
const ADVISORY_ISSUES: ReadonlySet<string> = new Set([
  'unwired_arm',
  'notify_owner_not_linked',
]);

export function isAdvisoryIssue(issue: Pick<GraphIssue, 'code'>): boolean {
  return ADVISORY_ISSUES.has(issue.code);
}
